import { Tenant } from '../tenant';
import { Organization } from '../organization';
import { SynopticFile } from './synoptic-file';

export class Synoptic {
  uuid: string;
  name: string;
  description: string;
  configuration: string;
  tenant: Tenant;
  organization: Organization;
  files: SynopticFile[];
}
